import {Injectable} from '@angular/core';
import {Seatmap} from '@ibe.models/seatmap.model.lib';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../../../../store';
import {Observable} from 'rxjs';
import * as _ from 'lodash';
import {take} from 'rxjs/operators';

@Injectable()
export class SeatmapUxResolver implements Resolve<Seatmap> {

	constructor(
		private store: Store<fromStore.State>,
	) {
	}

	resolve(route: ActivatedRouteSnapshot): Observable<Seatmap> {
		return this.store.select(fromStore.getSeatmap)
			.pipe(
				take(1)
			);
	}

}
